// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"0060f116","598":"3c61bbf5"}[chunkId] + ".chunk.js";
};